import type { Option } from 'ui-component-library/components/00-Primitives/Inputs/Dropdown'
import FilterDropdown from '../FilterDropdown'
import FilterIcon from 'ui-component-library/icons/filter.svg'

type Props = {
  onChange: (value: string) => void
  options: Option[]
  labelText: string
  selectedOption?: string
}

function TopicFilterDropdown({
  onChange,
  selectedOption,
  labelText,
  options,
}: Props) {
  return (
    <FilterDropdown
      onChange={onChange}
      Icon={FilterIcon}
      labelText={labelText}
      options={options}
      selectedOption={selectedOption}
    />
  )
}

export default TopicFilterDropdown
